import { useMemo } from 'react'
import { Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router-dom'
import ProjectMain from './project/ProjectMain'
import NewProjectPage from './project/NewProjectPage'
import FullDocumentationPage from './project/FullDocumentationPage'
import SingleChapterPage from './project/SingleChapterPage'

const DashboardProjectRoute = () => {
  const [searchParams] = useSearchParams()
  const location = useLocation()

  const preselectedTopicId = searchParams.get('topicId') || null
  const autoGenerateDocOnCreate = searchParams.get('autoGenerate') === '1'

  const preselectedTopic = useMemo(() => {
    const fromState = location?.state?.topic
    if (!fromState) return null
    return fromState
  }, [location?.state?.topic])

  return (
    <Routes>
      <Route
        index
        element={
          preselectedTopicId ? (
            <Navigate
              to={`new${searchParams.toString() ? `?${searchParams.toString()}` : ''}`}
              state={location.state}
              replace
            />
          ) : (
            <ProjectMain
            />
          )
        }
      />
      <Route
        path="new"
        element={
          <NewProjectPage
            preselectedTopicId={preselectedTopicId}
            preselectedTopic={preselectedTopic}
          />
        }
      />
      <Route path="full/:docId" element={<FullDocumentationPage />} />
      <Route path="chapter/:docId/:chapterId" element={<SingleChapterPage />} />
    </Routes>
  )
}

export default DashboardProjectRoute

